/*
 * O alerta "O evento X começa às 10:00" (tipo `canelaEventReminder`), mandado
 * pelo comando agendado a quem marcou "Vou". Leva à discussão do evento.
 */
import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { dayAndTime } from './format';
import { t } from '../../utils/settings';
export default class EventReminderNotification extends Notification {
  icon() {
    return 'far fa-calendar';
  }
  discussion() {
    return this.attrs.notification.subject() || null;
  }
  href() {
    const discussion = this.discussion();
    return discussion ? app.route.discussion(discussion) : '';
  }
  content() {
    const data = this.attrs.notification.content() || {};
    const name = data.name || this.discussion()?.title() || '';
    const when = data.startsAt ? dayAndTime(new Date(data.startsAt)) : '';
    return t('events.notification.text', {
      name,
      when
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('ramon-canela', 'forum/features/events/EventReminderNotification', EventReminderNotification);